import { basicBlockActions } from 'articleEditor/utils/actions';
import cx from 'classnames';
import { MyDividerElement } from 'lib-knowledge-document-structure/plateTypes';
import { RenderElementProps } from 'lib-knowledge-document-structure/slate/react';
import { useMemo } from 'react';

import s from '../baseBlock/block.module.scss';
import SortableBlockWrapper from '../baseBlock/sortableBlockWrapper';

type Props = RenderElementProps & {
  element: MyDividerElement;
};

export default function Divider({
  attributes,
  element,
  children,
}: Props): JSX.Element {
  const blockActions = useMemo(() => basicBlockActions, []);
  return (
    <SortableBlockWrapper
      // Prevent the cursor from appearing when clicking.
      onMouseDown={(e) => e.preventDefault()}
      element={element}
      blockActions={blockActions}
    >
      <div
        {...attributes}
        className={cx(s['blockDivider'], s['blockContent'])}
        contentEditable={false}
      />
      {children}
    </SortableBlockWrapper>
  );
}
